import { IApiError } from '@/models/apiError.model';
import { IMetaTag } from '@/models/metaTags.model';
import { IPagination } from '@/models/pagination.model';
import { TGetRedirectsQuery } from '../helpers/types';

export const META_TAGS_SLICE_NAME = 'metatags';

export interface MetaTagsListState {
  metaTagsList: {
    data: IMetaTag[];
    meta: IPagination;
  } | null;
  isLoading: boolean;
  error: IApiError | null;
  query: TGetRedirectsQuery | null;
}

export const initialState: MetaTagsListState = {
  metaTagsList: null,
  isLoading: false,
  query: null,
  error: null,
};
